import { createConsumer, createSubscriber, IEvent } from '@cian/events-log';
import { useEffect, useState, useMemo } from 'react';

type TEvent = {
  jsonQuery: object;
};

type TReturnValue = {
  jsonQuery: object | null;
};

export const useChatbotFiltersEventsSubscribe = (): TReturnValue => {
  const [jsonQuery, setJsonQuery] = useState<object | null>(null);

  useEffect(() => {
    const consumer = createConsumer({ topic: 'filters' });

    const chatbotFiltersSubscriber = createSubscriber((event: IEvent<unknown>) => {
      switch (event.type) {
        case 'setJsonQuery':
          setJsonQuery((event.value as TEvent).jsonQuery);
          break;
      }
    });

    consumer.subscribe(chatbotFiltersSubscriber);

    return () => {
      consumer.unsubscribe(chatbotFiltersSubscriber);
      consumer.destroy();
    };
  }, []);

  return useMemo(() => ({ jsonQuery }), [jsonQuery]);
};
